import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Fetch Array (credit bureau) data
// Returns full Lambda response: { verified_debt, array, crs, crsError }
export async function fetchArrayData({
  firstName,
  lastName,
  address,
  city,
  state,
  zip,
  dob, // format: YYYY-MM-DD
  ipAddress,
  forceCRS = false, // When true, forces CRS API call (used when ?crs=1 URL param is present)
  creditPullPrimary = null,
  creditPullFallback = null
}) {
  const config = {
    method: 'post',
    url: ENDPOINTS.ARRAY,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      firstName,
      lastName,
      address: {
        street: address,
        city,
        state,
        zip
      },
      dob,
      userConsent: {
        ipAddress,
        timestamp: new Date().toISOString(),
        url: 'https://firstadvantage.io/app/'
      },
      forceCRS,
      ...(creditPullPrimary
        ? {
            creditPullPrimary,
            creditPullFallback: creditPullFallback || 'off'
          }
        : {})
    }
  }

  try {
    const response = await axios.request(config)
    console.log('Array data response:', response.data)

    // Return full Lambda response for caller to handle
    // Response shape: { verified_debt, array, crs, crsError }
    return response.data
  } catch (error) {
    console.error('Array data fetch failed:', error)
    return null
  }
}

// Parse Array API response into a normalized format
export function parseArrayResponse(data) {
  if (!data || typeof data !== 'object') {
    return null
  }

  const result = {
    collections: null,
    credit_score: null,
    delinquencies: null,
    total_unsecured_debt: null,
    tax_liens: null,
    open_student_loan_bal: null
  }

  if (!data.hasOwnProperty('results')) {
    return result
  }

  // Extract values from results object
  for (const key in data.results) {
    if (data.results.hasOwnProperty(key) && result.hasOwnProperty(key)) {
      const resultObj = data.results[key]
      for (const resultKey in resultObj) {
        if (resultObj.hasOwnProperty(resultKey)) {
          if (resultObj[resultKey]) {
            result[key] = resultKey
          }
        }
      }
    }
  }

  return result
}

export const arrayService = {
  fetchArrayData,
  parseArrayResponse
}
